module.exports = ".selected {\n  background-color: rgba(178, 238, 242, 0.3); }\n\n.new-driver-bonuses .list-container form fieldset .bonus-values {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 10px 0;\n  padding: 10px; }\n\n.new-driver-bonuses .list-container form fieldset .bonus-values mat-form-field {\n    margin: 0 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-tariffs/new-driver-bonuses-tab/new-driver-bonuses-tab.component.scss
// module id = ./src/app/driver-tariffs/new-driver-bonuses-tab/new-driver-bonuses-tab.component.scss
// module chunks = main